<template>
  <div class="clearfix">
    <ActiveAccount class="chart" />
    <NewAccount class="chart" />
    <NewProduct
      class="chart"
      style="margin-right: 0;"
    />
    <Detail
      :visible="visible"
      @close="handleClose"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import ActiveAccount from './ActiveAccount/Index';
import NewAccount from './NewAccount/Index';
import NewProduct from './NewProduct/Index';
import Detail from './Detail/Index';

const { mapState, mapActions } = createNamespacedHelpers(
  'directSaleReport/dataView',
);

export default {
  components: {
    ActiveAccount,
    NewAccount,
    NewProduct,
    Detail,
  },

  computed: {
    ...mapState({
      visible: (state) => state.visible,
    }),
  },

  methods: {
    ...mapActions(['updateVisible']),

    handleClose() {
      this.updateVisible(false);
    },
  },
};
</script>

<style lang="less" scoped>
.chart {
  float: left;
  margin: 0 22px 22px 0;
  width: 356px;
  height: 370px;
  box-sizing: border-box;
}
</style>